import type { Org } from '#shared/types/Org'
import type { PaymentSuccessData } from '#shared/types/OrgTransaction'

/**
 * Composable for payment-related functionality
 */
export function usePayment() {
    const { $api } = useNuxtApp()

    /**
     * Gets payment success data
     */
    const getPaymentSuccessData = async (orgSlug: Org['slug'], token: string): Promise<PaymentSuccessData> => {
        const response = await $api.post<PaymentSuccessData>('payment/success', { orgSlug, token })
        return response.data
    }

    return {
        getPaymentSuccessData
    }
}
